"use client";
import { SectionItem } from "@/app/lib/features/home/home.types";
import CategoriesSwiper from "../../elements/swipers/CategoriesSwiper";
import { useTrackView } from "@/app/hooks/useTrackView";

interface CategoriesSectionProps {
  categories?: SectionItem[];
  title?: string;
  description?: string;
  sectionId?: number;
}

const CategoriesSection = ({
  categories,
  title,
  description,
  sectionId,
}: CategoriesSectionProps) => {
  const trackRef = useTrackView("section", sectionId);

  return (
    <section ref={trackRef}>
      <h2 className="text-lg sm:text-xl font-medium">
        {title || "Tozlu sana çok yakışıyor."}
      </h2>
      <p className="text-base sm:text-lg font-medium italic text-muted-foreground mb-2 sm:mb-3">
        {description || "Öne çıkmak için @tozlu etiketini kullan."}
      </p>
      <CategoriesSwiper categories={categories} />
    </section>
  );
};

export default CategoriesSection;
